import { render, staticRenderFns } from "./OverviewElement.vue?vue&type=template&id=23346cb8&scoped=true&"
import script from "./OverviewElement.vue?vue&type=script&lang=ts&"
export * from "./OverviewElement.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewElement.vue?vue&type=style&index=0&id=23346cb8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23346cb8",
  null
  
)

export default component.exports